// Status badge configuration for transaction and subscription states
export const getStatusConfig = (state) => {
  const s = (state || "").toUpperCase();
  let formattedState = state || "";
  let badgeVariant = "neutral";

  if (s === "SUCCEEDED" || s === "SUCCESS") {
    formattedState = "Succeeded";
    badgeVariant = "success";
  } else if (s === "ACTIVE") {
    formattedState = "Active";
    badgeVariant = "success";
  } else if (s === "FAILED" || s === "ERROR") {
    formattedState = "Failed";
    badgeVariant = "danger";
  } else if (s.includes("DISPUTED")) {
    formattedState = "Disputed";
    badgeVariant = "danger";
  } else if (s === "DEACTIVATED") {
    formattedState = "Deactivated";
    badgeVariant = "danger";
  } else if (s === "PENDING") {
    formattedState = "Pending";
    badgeVariant = "warning";
  } else if (s === "PAUSED") {
    formattedState = "Paused";
    badgeVariant = "warning";
  } else if (s === "CANCELLED" || s === "CANCELED") {
    formattedState = "Canceled";
    badgeVariant = "warning";
  } else if (s === "PARTIAL_REFUND") {
    formattedState = "Partial Refund";
    badgeVariant = "neutral";
  } else if (s === "FULL_REFUND" || s === "REFUNDED") {
    formattedState = "Full Refund";
    badgeVariant = "neutral";
  } else if (s) {
    formattedState = s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  }

  return { formattedState, badgeVariant };
};
